





























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Route} from 'vue-router';

@Component({})
export default class HomeChallengeButton extends Vue {
  @Prop({required: true}) description!: string;
  @Prop({required: true}) icon!: string;
  @Prop({required: true}) title!: string;
  @Prop({required: false}) to!: string
}
